import { Component, Inject, ViewChild } from '@angular/core';
import { ValueFormatter } from '../../../../../../../../../../../common/components/data-table/formatters/data-table.formatters';
import { Rule } from '../../../../../../../../../../../common/models/flow.dto';
import { genId } from '../../../../../../../../../../../core/services/genId';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DATA_TOKEN } from '../../../../grid-option-config/tokens';
import { RulesEditorComponent } from '../../../../../../../../../../../common/components/rules-editor/rules-editor.component';

@Component({
    selector: 'array-selector-options',
    templateUrl: './array-selector-options.component.html',
    styleUrls: ['./array-selector-options.component.scss'],
    standalone: false
})
export class ArraySelectorOptionsComponent {
    @ViewChild(RulesEditorComponent, { static: true })
    editor: RulesEditorComponent;

    formControl: AbstractControl;
    types = ValueFormatter;
    rule: Rule = {
        name: this.types.ArraySelector,
        ruleId: genId()
    };

    constructor(
        @Inject(DATA_TOKEN) public data: AbstractControl
    ) {
        this.formControl = this.data;

        if (this.formControl.value)
            this.rule = this.formControl.value;
    }

    ngAfterViewInit() {
        this.editor.compileSuccess.subscribe((result) => {
            this.formControl.updateValueAndValidity();
        });

        this.formControl.setValidators((c: AbstractControl): null | ValidationErrors => {
            return this.editor.compileSuccessful === true ? null : { error: "Compile not successful." } as ValidationErrors;
        });

        this.formControl.updateValueAndValidity({ emitEvent: true });
    }

    updateRule(rule: Rule) {
        this.rule = rule;
        this.formControl.setValue(rule);
    }
}
